import styles from "../styles/chat.module.scss";
import {
  ReactElement,
  useMemo,
  useEffect,
  useRef,
  useState,
  useCallback,
  createContext,
  useContext,
} from "react";
import Router, { useRouter } from "next/router";
import http from "../http";
import { ShowMessage } from "../components/ShowMessage/ShowMessage";
import { Mask, Modal, Popup } from "antd-mobile";
import LoadingIcon from "../components/Icon/LoadingIcon";
import Login from "./login";
import { isWeChatBrowser } from "../utils/util";
import { wxappId } from "../global";
import React from "react";
import ChatpdfBox from "../components/common/ChatpdfBox";
import { useUserInfo } from "../context/ThemeContext";
export interface productType {
  alias: string;
  description: string;
  discount_price: number;
  name: string;
  price: number;
  status: number;
  timestamp: string;
  update_timestamp: string;
  uuid: string;
  is_buy: boolean;
}
interface threadType {
  thread_id: string;
  fileData: {
    file_id?: string;
    file_name?: string;
  };
  setFileData: (data: { file_id?: string; file_name?: string }) => void;
  setThread: (thread_id: string) => void;
}
const ThreadContext = createContext<threadType | undefined>(undefined);
export default function Index() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [thread_id, setThread_id] = useState<string>("");

  const { userInfo, getUserInfo } = useUserInfo();

  const chatBox = useRef<any>();
  const [fileData, setFile] = useState({});
  const [settingShow, setSettingShow] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);

  const handleLogin = () => {
    const host = location.host;
    let appId = process.env.NEXT_PUBLIC_WX_APP_ID || wxappId;
    let redirectUri = encodeURIComponent(`https://${host}`);
    const state = Math.random().toString(36).substring(2); // 可选参数，用于防止CSRF攻击
    const scope = "snsapi_userinfo"; // 授权作用域，获取用户信息
    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}&forcePopup=true#wechat_redirect`;
    window.location.href = authUrl;
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (router.isReady) {
      const { code, state, thread_id, bd_vid, utm_source, login, invite_code } =
        router.query;
      setThread(thread_id as string);
      bd_vid &&
        sessionStorage.setItem("bd_vid", bd_vid ? bd_vid.toString() : "");
      utm_source && sessionStorage.setItem("utm_source", utm_source.toString());
      invite_code &&
        sessionStorage.setItem("invite_code", invite_code.toString());
      if (isWeChatBrowser()) {
        if (token) {
          if (thread_id) {
            chatBox.current?.getChatLog(thread_id);
          } else {
            chatBox.current?.createNewChat(true);
          }
        } else if (code && state) {
          http
            .get(
              `/api/v1/account/wechat/access_token?code=${code}&state=${sessionStorage.getItem("invite_code")?sessionStorage.getItem("invite_code"):state}&bd_vid=${
                sessionStorage.getItem("bd_vid") || ""
              }`
            )
            .then((res: any) => {
              if (res.status) {
                localStorage.setItem("token", res.data.token);
                getInfo();
                // 路由参数已准备好，可以进行操作
                router.query.github_id && setSettingShow(true);
                chatBox.current && chatBox.current?.createNewChat(true);
                // 用户渠道来源接口调用
                if (res.data.openid && sessionStorage.getItem("utm_source")) {
                  http.post(`/api/v1/account/utm-source `, {
                    utm_source: sessionStorage.getItem("utm_source") || "",
                    openid: res.data.openid,
                  });
                }
                chatBox.current?.getPayProducts();
              } else {
                ShowMessage.error(res.message);
              }
            });
        } else {
          handleLogin();
        }
      } else {
        if (login) {
          setPopupVisible(true);
        } else if (thread_id && token) {
          chatBox.current?.getChatLog(thread_id);
        } else if (!thread_id && token) {
          chatBox.current?.createNewChat(true);
        } else if (thread_id && !token) {
          Router.push(
            thread_id ? `/?login=true&thread_id=${thread_id}` : `/?login=true`
          );
        }
      }
      if (token) {
        chatBox.current?.getPayProducts();
      }
    }
  }, [router]);
  useEffect(() => {
    // 页面刷新之后取消threadId的连接
    const ids: any[] = JSON.parse(localStorage.getItem("threadIds") || "[]");
    if (ids.length) {
      ids.forEach(async (id: string) => {
        await cancleChat(id);
      });
      localStorage.setItem("threadIds", JSON.stringify([]));
    }
    setVisible(true);
  }, []);

  const getInfo = useCallback(() => {
    getUserInfo();
  }, []);
  const setThread = (str: string) => {
    console.log("setThread", str || "");
    setThread_id(str);
  };
  const setFileData = (data: { file_id?: string; file_name?: string }) => {
    setFile(data);
  };
  const cancleChat = (thread_id: string) => {
    //取消与后端的聊天
    return new Promise((resolve, reject) => {
      http
        .post("api/v1/chat/cancel", { thread_id: thread_id })
        .then((data: any) => {
          if (data.status) {
            resolve(true);
          } else {
            resolve(false);
            ShowMessage.error(data.message);
          }
        });
    });
  };
  const chat = useMemo(() => {
    return (
      <ChatpdfBox
        reLoadCancleChat={cancleChat}
        cancleChat={cancleChat}
        setSettingShow={(is) => {
          setSettingShow(is);
        }}
        updateMenu={() => {}}
        ref={chatBox}
        repoClick={(isClose) => {}}
        gotoLogin={() => {
          !isWeChatBrowser() && setPopupVisible(true);
        }}
      />
    );
  }, []);
  return (
    <div className={styles.chatpdf}>
      <ThreadContext.Provider
        value={{ thread_id, setThread, fileData, setFileData }}
      >
        {chat}
      </ThreadContext.Provider>
      <Mask visible={isLoading} opacity="thin">
        <div className={styles.LayoutLoading}>
          <LoadingIcon size={40} />
        </div>
      </Mask>
      <Popup
        visible={popupVisible}
        bodyClassName={styles.payPopup}
        onClose={() => {
          setPopupVisible(false);
        }}
        closeOnMaskClick={false}
        bodyStyle={{ height: "80vh" }}
      >
        <Login
          success={() => {
            setPopupVisible(false);
            if (!!thread_id) {
              router.replace(`/?thread_id=${thread_id}`);
            } else {
              chatBox.current && chatBox.current?.createNewChat(true);
            }
          }}
        />
      </Popup>
      <Modal
        visible={visible}
        bodyClassName={styles.darkModal}
        content={
          <div className={styles.headMoadl}>
            <p className={styles.text}>CodeBot Eagle新增Wiki功能</p>
            <p className={styles.text}>请使用电脑端登录</p>
            <p className={styles.text}>体验完整功能</p>
          </div>
        }
        closeOnAction
        onClose={() => {
          setVisible(false);
        }}
        actions={[
          {
            key: "confirm",
            style: { color: "var(--primary-text-color)" },
            text: "确认",
          },
        ]}
      ></Modal>
    </div>
  );
}
export const useThread = (): threadType => {
  const context = useContext(ThreadContext);
  if (!context) {
    throw new Error("useThread must be used within a ThreadProvider");
  }
  return context;
};
